export const hasAccess = (role = 'user') => {
    return (
        (role === 'admin') || (role === 'manager')
    );
};

export const isAdmin = (role = 'user') => (role === 'admin');
export const getIsManager = (role = 'user') => (role === 'manager');
